import * as React from 'react';
import { Flex, Box, Icon, NotificationAlert, NotificationType, Checkbox, Select, Paragraph, TrustpilotSpinner,
    } from '../CommonUI';
import Button from '../CommonUI/Control/Button';
import { Text } from 'ilenia';
import { StyleSheet, css } from 'aphrodite';
import { giveConsent, getConsentSpecifications } from '../Api/businessConsentsClient';
import { Consent as ConsentModel, ConsentType, ConsentSpecification, BusinessUnit } from '../Model';
import { getBusinessUnits } from '../Api/businessUserClient';

interface ConsentProps {
    source: string;
    isFromMarketplace: string;
    onConfirm: (businessUnitId: string) => void;
    tierName: string;
    mode?: string;
    locale: string;
}

interface ConsentState {
    accepted: boolean;
    consentSpecification?: ConsentSpecification;
    businessUnits?: BusinessUnit[];
    selectedBusinessUnitId: string;
}

export class Consent extends React.Component<ConsentProps, ConsentState> {
    constructor(props: ConsentProps) {
        super(props);
        this.state = {
            accepted: false,
            selectedBusinessUnitId: '',
        };
        this.onAccept = this.onAccept.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        this.onBusinessUnitChange = this.onBusinessUnitChange.bind(this);
    }

    public componentDidMount() {
        const { locale } = this.props;
        Promise.all([getConsentSpecifications(ConsentType.Ecomm, locale), getBusinessUnits()])
            .then((results) => {
                const [consentSpecs, businessUnits] = results;
                this.setState({
                    consentSpecification: consentSpecs.length > 0 ? consentSpecs[0] : { text: '', type: ConsentType.Ecomm, locale: '', version: -1, title: '' },
                    businessUnits,
                    selectedBusinessUnitId: businessUnits.length > 0 ? businessUnits[0].id : ''
                });
            });
    }

    public onAccept() {
        this.setState({ accepted: !this.state.accepted });
    }

    public onConfirm() {
        const { onConfirm } = this.props;
        const { selectedBusinessUnitId, consentSpecification } = this.state;
        const consent: ConsentModel = {
            isAccepted: true,
            type: consentSpecification!.type,
            unitId: selectedBusinessUnitId,
            version: consentSpecification!.version,
        };

        return giveConsent(consent)
            .then(async (given: boolean) => {
                if (given) {
                    NotificationAlert.alert(NotificationType.Success, 'consent.success');
                    await onConfirm(selectedBusinessUnitId);
                } else {
                    NotificationAlert.alert(NotificationType.Error, 'consent.error');
                }
            });
    }

    public onBusinessUnitChange(type: string, selectedBusinessUnitId: string) {
        this.setState({ selectedBusinessUnitId });
    }

    public render() {
        const { accepted, consentSpecification, businessUnits, selectedBusinessUnitId } = this.state;
        const { source, isFromMarketplace, tierName, mode } = this.props;
        if (!businessUnits || !consentSpecification) {
            return <TrustpilotSpinner active={true} height="500px"/>;
        }
        const businessUnitOptions = businessUnits
            .map((businessUnit) => ({ value: businessUnit.id, label: businessUnit.name!.identifying }));
        const businessUnitObject = businessUnits.find((businessUnit) => businessUnit.id === selectedBusinessUnitId);
        const businessUnitValue = (businessUnitObject)
            ? { value: businessUnitObject.id, label: businessUnitObject.name!.identifying }
            : { value: '', label: '' };

        return (
            <div className={css(styles.container)}>
                <Flex>
                    <Box pl={20}>
                        <Icon icon="trustpilot-logo" />
                        <Icon icon="arrow" styles={[styles.arrow]}/>
                        <Icon icon={`${source.toLowerCase()}-logo`} styles={[styles[source.toLowerCase()]]} />
                    </Box>
                    {businessUnits.length > 1 ?
                        <Select
                            id="business-unit"
                            label="consent.businessUnit"
                            value={businessUnitValue}
                            onChangeEvent={this.onBusinessUnitChange}
                            data={businessUnitOptions}
                        /> :
                        <Paragraph caption="consent.oneBusinessUnit" text={businessUnitValue.label} boldText={true} />
                    }
                    <Paragraph text={consentSpecification.text} />
                    <Checkbox
                        id="acceptConsent"
                        label="consent.acceptedLabel"
                        onChange={this.onAccept}
                        checked={accepted}
                    />
                    <Button
                        onClick={this.onConfirm}
                        preventDoubleClick={true}
                        disabled={!accepted || !selectedBusinessUnitId}
                        track={{
                            placement: 'Bottom right corner',
                            action: 'Button confirm consent clicked',
                            name: 'confirm-consent-button',
                            source,
                            isFromMarketplace,
                            tierName,
                            mode,
                        }}
                    >
                        <Text id="consent.confirmLabel" />
                    </Button>
                </Flex>
            </div>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        maxWidth: '532px',
        margin: '30px 0px',
    },
    text: {
        lineHeight: '1.43',
        letterSpacing: 'normal',
        color: '#292929',
    },
    arrow: {
        width: '17px',
        height: '17px',
        padding: '0px 30px',
    },
    opencart: {
        width: '140px',
    }
});



// WEBPACK FOOTER //
// ./src/Containers/Consent.tsx